import { formatNumber } from './format-number';

export const formatCurrency = (value: number | null | undefined, currency: string | null | undefined): string => {
    const number = formatNumber(value, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
    if (!number) return '';
    if (!currency) return number;
    return `${number} ${currency.toUpperCase()}`;
};
